import api from './api';

export interface DepartamentoResult {
    id: string;
    enabled?: boolean;
    nome: string;
    descricao?: string;
    usuarioResponsavelId?: string;
    areaId: string;
    valid: boolean;
    sigla: string;
    diretoriaId: string;
    usuarioSubstitutoId?: string;
    dataFinal?: Date;
    dataInicial?: Date;
}
export interface Validacao {
    valid: boolean;
}


export interface DepartamentoPesquisaResult {
    id: string;
    enabled: boolean;
    nome: string;
    descricao: string;
    usuarioResponsavelId?: string;
    areaId: string;
    diretoriaId: string;
    valid: boolean;
    sigla: string;
    areaNome: string;
    nomeUsuario: string;
    userName: string;
}


export const getAllDepartamento = () => api.get<DepartamentoPesquisaResult[]>('departamentos');
export const getAllDepartamentoProAreaId = (areaId: string) => api.get<DepartamentoPesquisaResult[]>(`departamentos/getAllDepartamentoProAreaId/${areaId}`);
export const getAllDepartamentoProDiretoriaId = (diretoriaId: string) => api.get<DepartamentoPesquisaResult[]>(`departamentos/getAllDepartamentoProDiretoriaId/${diretoriaId}`);

export const createDepartamento = (departamento: DepartamentoResult) => {
    return api.post<any>('departamentos', departamento);
};
export const updateDepartamento = (departamento: DepartamentoResult) => api.put<any>(`departamentos/${departamento.id}`, departamento);
export const deleteDepartamento = (id: string) => api.delete<Validacao>(`departamentos/${id}`);

export const getAllDepartamentoOptions = () =>
    getAllDepartamento().then(areas => (areas || []).map(a => ({ text: a.nome, value: a.id.toString() })));


export const getAllDepartamentoProAreaIdOptions = (
    areaId: string,
    somenteAtivos = false,
    departamentoAtualId?: string,
) =>
    getAllDepartamentoProAreaId(areaId).then(departamentos => (departamentos || [])
        .filter(departamento =>
            !somenteAtivos || departamento.enabled === true || departamento.id === departamentoAtualId)
        .map(departamento => ({ text: departamento.nome, value: departamento.id.toString() })));

export const getAllDepartamentoProDiretoriaIdOptions = (
    diretoriaId: any,
    somenteAtivos = false,
    departamentoAtualId?: string,
) =>
    getAllDepartamentoProDiretoriaId(diretoriaId).then(departamentos => (departamentos || [])
        .filter(departamento =>
            !somenteAtivos || departamento.enabled === true || departamento.id === departamentoAtualId)
        .map(departamento => ({ text: departamento.nome, value: departamento.id.toString() })));
